import { FunctionComponent } from 'react';
import { Close } from '../icons';
import { Typography, IconButton, Paper } from '../../tailwindcomponents';

type DictionaryProps = {
  object: any,
  name: string,
  id: number,
  deleteProperty: Function,
  descriptionStrings?: string[],
  description?: string,
  other?: string,
  deleted: boolean,
  deleteButton?: boolean
}
const Dictionary: FunctionComponent<DictionaryProps> = ({ object, name, id, deleteProperty, descriptionStrings = [], description = '', deleted = false, other = '', deleteButton = true }) => {

  return (
    <div className="w-5/6">
      <Paper key={id} elevation={10} variant="elevation" className="mt-4 mb-4" style={deleted ? { backgroundColor: '#9c27b0' } : undefined}>
        <div className="flex content-center items-center w-full">
          <div className="w-5/6">
            <Typography align='center' variant='h2' text={name} margin={[1, 0, 0, 0]} />
            {description !== '' && <Typography align='center' variant='body1' text={description} margin={[0, 0, 0, 0]} />}
            {other !== '' && <Typography align='center' variant='body1' text={other} margin={[0, 0, 0, 0]} />}
            {descriptionStrings.map(string => (
              <Typography align='center' variant='body1' text={string} margin={[0, 0, 0, 0]} />
            ))}
          </div>
          {deleted === false && deleteButton === true &&
            <div>
              <div className="w-1/6">
                <IconButton className="relative left-4" onClick={() => deleteProperty(object)} >
                  <Close />
                </IconButton>
              </div>
            </div>
          }
        </div>
      </Paper>
    </div>
  );
};
export default Dictionary